.cropImageModal {
  z-index: 1500;

  > .content {
    max-height: calc(100vh - 4rem);

    @media (min-width: 769px) {
      max-width: 27.5rem;
    }
  }
}
